import { BehaviourTag } from '../../model/behaviour-tag.model';

export interface BehaviourSelectionDialogState {
    behaviourTagSelection?: BehaviourTag[];
    hasPendingData?: Boolean;
}

export const defaultState = (): BehaviourSelectionDialogState => ({});
